var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Hey There 🙌"}},[_c('b-card-text',[_vm._v("Awesome Content coming soon")]),_c('b-card-text',[_vm._v("Something cool is coming here soon")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }